import { Share2, Tags } from 'lucide-react'
import { SeoConfigTable } from './SeoConfigTable'
import { SEO_STR as S } from './seoApi'

/**
 * A12.02 — Meta teg shablonlari. Path-shablon → title/description shablonlari.
 * CRUD `/admin/seo/meta-templates` (fail-soft).
 */
export function MetaTemplatesScreen() {
  return (
    <SeoConfigTable
      screenId="A12.02"
      title={S.metaTemplates}
      addLabel={S.addMeta}
      path="/admin/seo/meta-templates"
      listKey="templates"
      searchKeys={['pattern', 'title']}
      icon={<Tags size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'pattern', placeholder: '/blog/*', mono: true },
        { name: 'title', placeholder: S.metaTitleCol },
        { name: 'description', placeholder: S.metaDesc },
      ]}
      columns={[
        { key: 'pattern', header: S.pattern, type: 'text' },
        { key: 'title', header: S.metaTitleCol, type: 'text' },
        { key: 'description', header: S.metaDesc, type: 'longtext' },
      ]}
    />
  )
}

/**
 * A12.03 — OpenGraph / Twitter Card. Path → og:title / og:image kartalari.
 * CRUD `/admin/seo/opengraph` (fail-soft).
 */
export function OpenGraphScreen() {
  return (
    <SeoConfigTable
      screenId="A12.03"
      title={S.openGraph}
      addLabel={S.addOg}
      path="/admin/seo/opengraph"
      listKey="entries"
      searchKeys={['path', 'og_title']}
      icon={<Share2 size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'path', placeholder: '/', mono: true },
        { name: 'og_title', placeholder: S.metaTitleCol },
        { name: 'og_image', placeholder: S.image, mono: true },
      ]}
      columns={[
        { key: 'path', header: S.path, type: 'text' },
        { key: 'og_title', header: S.metaTitleCol, type: 'text' },
        { key: 'og_image', header: S.image, type: 'text' },
      ]}
    />
  )
}
